<template>
    <div class="components-container">
        <div class="filter-container">
            <el-select v-model="queryForm.state" filterable placeholder="请选择状态" style="width:200px;" clearable>
                <el-option v-for="item in comboData.state" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                </el-option>
            </el-select>
            <el-button @click="handleFilter" type="gray" style="margin-left: 10px"><i class="el-icon-search"></i>&nbsp;查询</el-button>
        </div>

        <el-table :data="tableData" v-loading.body="tableLoading" element-loading-text="信息加载中" :cell-style="handleCellStyle"
            highlight-current-row stripe border fit style="width: 100%" :height="mainTableHeight" ref="mainTable">
            <el-table-column fixed :label="'审核\n层级'" prop="auditLevel" align="center" width="50"></el-table-column>
            <el-table-column :label="'审核\n状态'" prop="auditState" align="center" width="60"></el-table-column>
            <el-table-column :label="'审核\n意见'" prop="opinion" align="center" width="150"></el-table-column>
            <el-table-column label="审核人" prop="auditor" align="center" width="100"></el-table-column>
            <el-table-column :label="'审核\n时间'" prop="auditTime" align="center" width="100"></el-table-column>
            <el-table-column label="状态" prop="state" align="center" width="60"></el-table-column>
        </el-table>
    </div>
</template>

<script>
    export default {
        props: ['relatedCode','listHeight'],
        data() {
            return {
                comboData: {
                    state: null,
                },
                mainTableHeight: 400,
                queryForm: {
                    relatedCode: null,
                    state: null,
                },
                tableData: [],
                tableLoading: false,
            };
        },
        mounted() {
            this.queryForm.relatedCode = this.relatedCode;
            this.initCombo();
            this.queryList();

            this.$nextTick().then(() => {
                if(this.listHeight){
                    this.mainTableHeight = this.listHeight;
                }
            });
        },
        methods: {
            initCombo() {
                this.$api.common.comboOption.common({
                    data: { type:'YXZT' }
                }).then((res) => {
                    this.comboData.state = res.data.data.comboData;
                }).catch((err) => {
                    console.log(err);
                });
            },
            handleFilter() {
                this.queryList();
            },
            queryList() {
                this.tableLoading = true;
                this.$api.common.audit.list({
                    data: this.queryForm,
                }).then((response) => {
                    this.tableData = response.data.data.list;
                    this.tableLoading = false;
                }).catch((error) => {
                    this.tableLoading = false;
                    console.log(error);
                });
            },
            handleCellStyle({row, column, rowIndex, columnIndex}){
                let cellStyle;

                if(columnIndex === 1){
                    switch (row.auditState) {
                        case '通过':
                            cellStyle = 'color: #00FF40 !important;';
                            break;
                        case '驳回':
                            cellStyle = 'color: #FE2E2E !important;';
                            break;
                        default:
                            cellStyle = '';
                    }

                    return cellStyle;
                }
            },
        },
    };
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// auditList.vue?3a9733f5